/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PlayIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAxUlEQVR4nO2VPQrCQBCFt7GyE7yJrTYSsHB+UqwzhXUOoafwCpbexlISWxXBEwQS2cXfVnYKIQ9eOx+8nXnrXKdfBblmyFoC6Q1Z1kVR9FxKIcsFWdu3ZY+oo4SAz+H6dA0kmyxb9q0AbTTJcU4ytQNwdIOsW+/9wArQBgPJCVFzMwC+YtPdzPuhHYAj5Iq4mNgBOESmlSkAWUvTiIhk/F+PDIZr2tgdGtlVRZ2u7EjP38MT13WIAEgPYfWAZJX8w+nkHroDI9Zf6QNiow0AAAAASUVORK5CYII=)
 */
export const PlayIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.25 3.35C7.87 2.45 6 3.38 6 4.96v14.08c0 1.58 1.87 2.5 3.25 1.61l10.85-7.04a1.9 1.9 0 0 0 0-3.22L9.25 3.35Z"
        className={colorClass}
      />
    </svg>
  );
};
